import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from 'src/components/sharedComponents/Card/Card'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import CardIcon from 'src/components/sharedComponents/Card/CardIcon'
import PriorityHighIcon from '@material-ui/icons/PriorityHigh'
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot'
import CardFooter from 'src/components/sharedComponents/Card/CardFooter'
import { TextField } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import CancelIcon from '@material-ui/icons/Cancel'
import Button from 'src/components/sharedComponents/CustomButtons/Button'

const buttonDirection = { flexDirection: 'row-reverse' }
const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}))

const IpcPage = props => {
  const { ipc, icc, onUpdateIpc, onUpdateIcc, handleChangeIpc, updateIpc, loading } = props
  const [isUpdateIpc, setIsUpdateIpc] = useState(false || loading)
  const [isUpdateIcc, setIsUpdateIcc] = useState(false || loading)

  const classes = useStyles()

  return (
    <>
      <CardTitle title="Índice de Precios al Consumidor (IPC) " />
      <Card>
        <CardHeader color="customAuteco" stats icon>
          <CardIcon color="customAuteco">
            <PriorityHighIcon />
          </CardIcon>
        </CardHeader>
        <CardBody>
          {!isUpdateIpc ? (
            <>
              <h3>Actualización IPC</h3>
              <p>
                * Año:
                {ipc?.YYYY}
              </p>
              <p>
                * Mes:
                {ipc?.MM}
              </p>
              <p>
                * Indice:
                {ipc?.INDICE}
              </p>
              <p>
                * Variación:
                {ipc?.VARIACION}
              </p>
            </>
          ) : (
            <>
              <h1>Actualización</h1>
              <form required className={classes.root} noValidate autoComplete="off">
                <TextField
                  fullWidth
                  id="filled-basic"
                  label="Indice"
                  variant="filled"
                  required
                  onChange={event => handleChangeIpc('indice', event.target.value)}
                  value={updateIpc.indice}
                />
                <TextField
                  fullWidth
                  id="filled-basic"
                  label="Variación"
                  variant="filled"
                  required
                  onChange={event => handleChangeIpc('variacion', event.target.value)}
                  value={updateIpc.variacion}
                />
              </form>
            </>
          )}
        </CardBody>
        <CardFooter style={buttonDirection}>
          <Button
            variant="contained"
            color="warning"
            onClick={() => (!isUpdateIpc ? setIsUpdateIpc(!isUpdateIpc) : onUpdateIpc())}
          >
            {!isUpdateIpc ? 'Editar' : 'Guardar'}
          </Button>
          {isUpdateIpc && (
            <IconButton onClick={() => setIsUpdateIpc(!isUpdateIpc)} aria-label="delete">
              <CancelIcon style={{ fontSize: '18px', color: 'red' }} />
            </IconButton>
          )}
        </CardFooter>
      </Card>
      <Card>
        <CardHeader color="customAuteco" stats icon>
          <CardIcon color="customAuteco">
            <ScatterPlotIcon />
          </CardIcon>
        </CardHeader>
        <CardBody>
          {!isUpdateIcc ? (
            <>
              <h3>Actualización ICC</h3>
              <p>
                * Año:
                {icc?.YYYY}
              </p>
              <p>
                * Mes:
                {icc?.MM}
              </p>
              <p>
                * Valor:
                {icc?.VALOR}
              </p>
            </>
          ) : (
            <>
              <TextField
                fullWidth
                id="filled-basic"
                label="Valor"
                variant="filled"
                required
                onChange={event => handleChangeIpc('valor', event.target.value)}
                value={updateIpc.valor}
              />
            </>
          )}
        </CardBody>
        <CardFooter style={buttonDirection}>
          <Button
            variant="contained"
            color="warning"
            onClick={() => (!isUpdateIcc ? setIsUpdateIcc(!isUpdateIcc) : onUpdateIcc())}
          >
            {!isUpdateIcc ? 'Editar' : 'Guardar'}
          </Button>
          {isUpdateIcc && (
            <IconButton onClick={() => setIsUpdateIcc(!isUpdateIcc)} aria-label="delete">
              <CancelIcon style={{ fontSize: '18px', color: 'red' }} />
            </IconButton>
          )}
        </CardFooter>
      </Card>
    </>
  )
}

export default IpcPage
